import { apiClient } from '../common/utils/apiClient';
import { API_CONFIG } from '../config/api';
import { sessionStorageUtils } from '../common/utils/sessionStorage';
import { ValuesetParam } from '../common/utils/valueset';


// Real masters service using Valueset APIs
export const mastersService = {
  // Generic valueset fetch by param code
  getValuesByParam: async (param: ValuesetParam): Promise<{ data: any[]; rowCount: number }> => {
    const token = sessionStorageUtils.getToken();
    if (!token) throw new Error('No authentication token');
    const response = await apiClient.get<any>(API_CONFIG.ENDPOINTS.VALUESET_BY_PARAM(param), token);
    
    // Normalize response to always return { data: [], rowCount: number }
    if (Array.isArray(response)) {
      return { data: response, rowCount: response.length };
    }
    if (response && Array.isArray(response.data)) {
      return { data: response.data, rowCount: response.rowCount || response.data.length };
    }
    return { data: [], rowCount: 0 };
  },

  // Create valueset record
  createValueset: async (payload: any): Promise<any> => {
    const token = sessionStorageUtils.getToken();
    if (!token) throw new Error('No authentication token');
    return apiClient.post<any>(API_CONFIG.ENDPOINTS.CREATE_VALUESET, payload, token);
  },

  // Update valueset record
  updateValueset: async (id: string, payload: any): Promise<any> => {
    const token = sessionStorageUtils.getToken();
    if (!token) throw new Error('No authentication token');
    return apiClient.put<any>(API_CONFIG.ENDPOINTS.UPDATE_VALUESET(id), payload, token);
  },

  // Convenience helpers
  getPackStatuses: async () => mastersService.getValuesByParam(ValuesetParam.PACK_STATUS),
  getPackComments: async () => mastersService.getValuesByParam(ValuesetParam.PACK_COMMENT),
  getUserRoles: async () => mastersService.getValuesByParam(ValuesetParam.USER_ROLE),
  getNada: async () => mastersService.getValuesByParam(ValuesetParam.NADA),


};
